<template>
  <div class="invoice-page">
    <v-head :title="title" route="SignUpmeetingCenter"></v-head>
    
    <div class="invoice-content">
      <!-- 发票类型选择 -->
      <van-field 
        required
        name="invoiceType" 
        label="发票类型"
        :rules="[{ required: true, message: '请选择发票类型' }]"
      >
        <template #input>
          <van-radio-group 
            v-model="invoiceParams.type" 
            @change="changeInvoiceType" 
            direction="horizontal"
          >
            <van-radio :name="1">普通发票</van-radio>
            <van-radio :name="2">增值税专用发票</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 抬头类型选择 -->
      <van-field 
        required
        name="invoiceTitleType" 
        label="抬头类型"
        :rules="[{ required: true, message: '请选择抬头类型' }]"
      >
        <template #input>
          <van-radio-group 
            v-model="invoiceParams.invoiceTitleType" 
            @change="changeInvoiceTitleType" 
            direction="horizontal"
          >
            <van-radio :name="2">单位</van-radio>
            <van-radio v-if="invoiceParams.type === 1" :name="1">个人</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 发票抬头 -->
      <van-field required v-model="invoiceParams.invoiceCompanyName" label="发票抬头"
        placeholder="点击更多选择历史发票信息" :rules="[{ required: true, message: '请输入发票抬头' }]"
        maxlength="64">
        <template #button>
          <span class="moreInvoice" @click="menuList()">更多<van-icon name="arrow" /></span>
        </template>
      </van-field>

      <!-- 纳税人识别号（仅单位） -->
      <van-field 
        required
        v-if="invoiceParams.invoiceTitleType === 2"
        v-model="invoiceParams.tin" 
        label="纳税人识别号"
        placeholder="请输入纳税人识别号"
        :rules="[
          { required: true, message: '请输入纳税人识别号' },
          { validator: validateTin, message: '请输入正确的纳税人识别号' }
        ]"
        maxlength="18"
      />

      <!-- 收票人邮箱 -->
      <van-field 
        required
        v-model="invoiceParams.invoiceEmail" 
        label="收票人邮箱"
        placeholder="请输入邮箱"
        :rules="[
          { required: true, message: '请输入邮箱' },
          { validator: validateEmail, message: '请输入正确的邮箱格式' }
        ]"
        maxlength="64"
      />

      <!-- 更多内容（非必填）-->
      <div v-if="invoiceParams.invoiceTitleType === 2" >
        <van-field 
          v-model="invoiceParams.invoiceBank" 
          label="开户银行"
          maxlength="100" 
          placeholder="选填"
        />
        <van-field 
          v-model="invoiceParams.invoiceAccount" 
          label="开户账号" 
          maxlength="100" 
          placeholder="选填" 
        />
        <van-field 
          v-model="invoiceParams.invoiceAddress" 
          label="注册地址"
          maxlength="100" 
          placeholder="选填"
        />
        <van-field 
          v-model="invoiceParams.invoiceTelephone" 
          label="注册电话"
          maxlength="30" 
          placeholder="选填"
        />
        <van-field 
          type="textarea" 
          autosize
          v-model="invoiceParams.invoiceRemarks" 
          label="发票备注" 
          maxlength="65" 
          placeholder="选填"
        />
      </div>
    </div>
    
    <!-- 历史发票选择弹窗 -->
    <van-popup 
      v-model="showInvoice" 
      :close-on-click-overlay="false"
      position="bottom"
    >
      <van-picker 
        show-toolbar 
        ref="picker"
        value-key="value"
        :columns="columns" 
        @change="onChange"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>

    <div class="button-area">
      <van-button 
        type="primary" 
        block 
        class="submitButton"
        @click="submitInvoice"
        :loading="submitting"
        :disabled="!editable"
      >
        {{ isEditing ? '保存修改' : '提交发票信息' }}
      </van-button>
    </div>
    
  </div>
</template>

<script>
import vHead from '@/components/Subhead.vue'
import { mapState, mapActions } from 'vuex'
import { fillnvoicelnfo, getMeetingInvoiceInfo } from '@/api/dictionary'
import {
  Row,
  Col,
  Swipe,
  SwipeItem,
  DatetimePicker,
  Form,
  Icon,
  Field,
  Button,
  Toast,
  Tabs,
  Tab,
  Dialog,
  Radio,
  NavBar,
  Popup,
  Area,
  Cell,
  Checkbox,
  Divider,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  RadioGroup,
  NoticeBar,
  Stepper,
  Calendar,
  Picker,
} from "vant";

export default {
  name: 'InvoicePage',
  components: {
    vHead,
    [Row.name]: Row,
    [Col.name]: Col,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [DatetimePicker.name]: DatetimePicker,
    [Dialog.Component.name]: Dialog.Component,
    [NavBar.name]: NavBar,
    [NoticeBar.name]: NoticeBar,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Form.name]: Form,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Stepper.name]: Stepper,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Area.name]: Area,
    [RadioGroup.name]: RadioGroup,
    [Picker.name]: Picker,
    [Calendar.name]: Calendar,
  },
  data() {
    return {
      title: '填写发票信息',
      submitting: false,
      editable: true,
      isEditing: false,
      invoiceStatus: null,
      invoiceParams: {
        type: 1,
        invoiceTitleType: 2,
        invoiceCompanyName: '',
        invoiceEmail: '',
        tin: '',
        invoiceBank: '',
        invoiceAccount: '',
        invoiceAddress: '',
        invoiceTelephone: '',
        invoiceRemarks: '',
        info: '已填写0项'
      },
      // 从上个页面传递过来的数据
      meetingId: null,
      orderId: null,
      // 控制弹窗显示
      showHistoryPopup: false,
      showMoreDialog: false,
      historyColumns: [],
      showInvoice: false,
      columns: []
    }
  },
  computed: {
    ...mapState(['invoiceList'])
  },
  methods: {
    ...mapActions(['getInvoiceList']),
    menuList() {
      this.showInvoice = true;
      this.columns = this.invoiceList
    },
    // 取消选择
    onCancel() {
      this.showInvoice = false;
    },
    onChange(picker, values, index) {

    },
    onConfirm(item) {
      this.applyInvoiceInfo(item)
      this.showInvoice = false;
    },
    applyInvoiceInfo(item) {
      this.invoiceParams = {
        tin: item.invoiceTin,
        type: item.invoiceType,
        invoiceCompanyName: item.value,
        invoiceTitleType: item.invoiceTitleType,
        invoiceBank: item.invoiceBank,
        invoiceAccount: item.invoiceAccount,
        invoiceTelephone: item.invoiceTelephone,
        invoiceRemarks: '',
        invoiceAddress: item.invoiceAddress,
        invoiceEmail: item.invoiceEmail,
        info: ''
      }
      this.calculateFilledItems()
    },
    // 改变发票类型
    changeInvoiceType(value) {
      if (value === 2) {
        this.invoiceParams.invoiceTitleType = 2;
      } else {
        this.invoiceParams.tin = ""
      }
      console.log('Invoice type changed:', value)
    },

    // 改变抬头类型
    changeInvoiceTitleType(value) {
      if (value === 1) {
        this.invoiceParams.tin = "";
      }
      console.log('Invoice title type changed:', value)
    },

    // 关闭历史发票弹窗
    closeHistoryPopup() {
      this.showHistoryPopup = false
    },

    // 选择历史发票
    selectHistoryInvoice(selectedValue) {
      if (selectedValue) {
        // 更新表单数据
        Object.assign(this.invoiceParams, selectedValue)
        // 计算已填写项数量
        this.calculateFilledItems()
      }
      this.showHistoryPopup = false
    },

    // 计算已填写项数量
    calculateFilledItems() {
      let count = 0;
      if (this.invoiceParams.invoiceBank) count++;
      if (this.invoiceParams.invoiceAccount) count++;
      if (this.invoiceParams.invoiceAddress) count++;
      if (this.invoiceParams.invoiceTelephone) count++;
      if (this.invoiceParams.invoiceRemarks) count++;
      
      this.invoiceParams.info = `已填写${count}项`
    },

    // 验证纳税人识别号
    validateTin(value) {
      if (!value) return false
      return /^[0-9a-zA-Z]{1,20}$/.test(value)
    },

    // 验证邮箱
    validateEmail(value) {
      if (!value) return false
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(value)
    },

    // 验证整个表单
    validate() {
      const requiredFields = [
        { field: 'invoiceCompanyName', msg: '请输入发票抬头' },
        { field: 'invoiceEmail', msg: '请输入邮箱' }
      ]
      // 抬头类型为单位（invoiceTitleType=2），需要纳税人识别号
      if (this.invoiceParams.invoiceTitleType == 2) {
        requiredFields.push({ field: 'tin', msg: '请输入纳税人识别号' })
      }

      for (const req of requiredFields) {
        if (!this.invoiceParams[req.field]) {
          this.$toast(req.msg)
          return false
        }
      }

      // 验证邮箱格式
      if (!this.validateEmail(this.invoiceParams.invoiceEmail)) {
        this.$toast('请输入正确的邮箱格式')
        return false
      }
      // 验证纳税人识别号格式（抬头为单位）
      if (this.invoiceParams.invoiceTitleType === 2 && 
          this.invoiceParams.tin && 
          !this.validateTin(this.invoiceParams.tin)) {
        this.$toast('请输入正确的纳税人识别号')
        return false
      }

      return true
    },

    // 提交发票信息
    async submitInvoice() {
      if (!this.editable) {
        Toast.fail('发票已进入开票流程，不能修改')
        return
      }
      if (!this.validate()) {
        return
      }
      
      this.submitting = true
      
      try {
        const params = {
          id: this.orderId,
          invoiceType: this.invoiceParams.type,
          invoiceTitleType: this.invoiceParams.invoiceTitleType,
          invoiceCompanyName: this.invoiceParams.invoiceCompanyName,
          invoiceEmail: this.invoiceParams.invoiceEmail,
          invoiceTin: this.invoiceParams.tin,
          invoiceBank: this.invoiceParams.invoiceBank,
          invoiceAccount: this.invoiceParams.invoiceAccount,
          invoiceAddress: this.invoiceParams.invoiceAddress,
          invoiceTelephone: this.invoiceParams.invoiceTelephone,
          invoiceRemarks: this.invoiceParams.invoiceRemarks
        }
        
        const response = await fillnvoicelnfo(params)
        
        if (response.success) {
          Toast.success(this.isEditing ? '发票信息修改成功' : '发票信息提交成功')
          // 跳转回原页面
          this.$router.push({
            name: 'SignUpmeetingCenter'
          })
        } else {
          Toast.fail(response.message || '提交失败')
        }
      } catch (error) {
        console.error('提交发票信息失败:', error)
        Toast.fail('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },

    async loadInvoiceInfo() {
      if (!this.orderId) {
        this.editable = false
        Toast.fail('订单信息不存在')
        return
      }

      try {
        const response = await getMeetingInvoiceInfo({ orderId: this.orderId })
        if (!response.success) {
          this.editable = false
          Toast.fail(response.message || '获取发票信息失败')
          return
        }

        const invoiceInfo = response.result || {}
        this.invoiceStatus = invoiceInfo.invoiceStatus
        if (![1, 2].includes(invoiceInfo.invoiceStatus)) {
          this.editable = false
          Toast.fail('发票已进入开票流程，不能修改')
          return
        }

        this.isEditing = invoiceInfo.invoiceStatus === 2
        if (this.isEditing) {
          this.invoiceParams = {
            type: invoiceInfo.invoiceType || 1,
            invoiceTitleType: invoiceInfo.invoiceTitleType || 2,
            invoiceCompanyName: invoiceInfo.invoiceCompanyName || '',
            invoiceEmail: invoiceInfo.invoiceEmail || '',
            tin: invoiceInfo.invoiceTin || '',
            invoiceBank: invoiceInfo.invoiceBank || '',
            invoiceAccount: invoiceInfo.invoiceAccount || '',
            invoiceAddress: invoiceInfo.invoiceAddress || '',
            invoiceTelephone: invoiceInfo.invoiceTelephone || '',
            invoiceRemarks: invoiceInfo.invoiceRemarks || '',
            info: ''
          }
          this.calculateFilledItems()
        }
      } catch (error) {
        this.editable = false
        console.error('获取发票信息失败:', error)
        Toast.fail('获取发票信息失败，请稍后重试')
      }
    },

    // 历史选择变化事件
    onHistoryChange(picker, values, index) {
      // 如果需要在选择过程中做些什么，可以在这里处理
    }
  },
  
  async created() {
    // 获取路由参数
    this.meetingId = this.$route.query.meetingId
    this.orderId = this.$route.query.orderId

    const urlParams = new URLSearchParams(window.location.search);
    const memberId = urlParams.get('memberId');
    const accessToken = urlParams.get('access_token');
    if (memberId) {
      sessionStorage.setItem('memberId', memberId);
    }
    if (accessToken) {
      sessionStorage.setItem('access_token', accessToken);
    }
    // 获取历史发票列表
    await this.loadInvoiceInfo()
    try {
      const invoiceList = await this.getInvoiceList()
      if (this.invoiceStatus === 1 &&
          !this.invoiceParams.invoiceCompanyName &&
          invoiceList.length > 0) {
        this.applyInvoiceInfo(invoiceList[0])
      }
    } catch (error) {
      console.error('获取历史发票列表失败:', error)
    }
  }
}
</script>

<style scoped>
.invoice-page {

}

.invoice-content {
  padding: 2px;
  margin-top: 10px;
  background-color: #fff;
}

.more-invoice {
  color: #1989fa;
  font-size: 14px;
}

.more {
  /deep/ .van-cell__title {
    padding-left: 15px;
  }
}
.submitButton {
   background-color: #1989fa;
    border-radius: 25px;
    padding: 13px 0 13px 0;
}
.more-info-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f5f5f5;
}

.dialog-header .dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

.dialog-header .close-icon {
  font-size: 20px;
  color: #c8c9cc;
}

.dialog-body {
  padding: 16px;
}

.dialog-body /deep/ .van-field {
  margin-bottom: 16px;
}

.dialog-body /deep/ .van-field:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  padding: 16px;
  text-align: center;
}

.save-btn {
  width: 100%;
  background-color: #1989fa;
  border: none;
  border-radius: 25px;
  padding: 10px 0;
  color: #fff;
  font-size: 16px;
}

.save-btn .save-text {
  color: #fff;
}

.button-area {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 0 10px;
}
/deep/.van-field__label {
  width: 2.6rem;
}
.moreInvoice {
  display: flex;
  align-items: center;
  line-height: 17px;
  color: red;
}

</style>
